export default "__VITE_ASSET__Bznmthmx__"